// extracted by mini-css-extract-plugin
module.exports = {"EstimateHeader":"Page_EstimateHeader__8XCi5","EstimateTitle":"Page_EstimateTitle__AzLUL"};